import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from '@cfp/core';
import { EnergyLabelRequirementStatus } from '@cfp/features-shared/energy-label-requirement';
import { BuildingAddressDirective } from '@cfp/shared/building/address-module';
import { EnergyLabel } from '@cfp/shared/energy-label';
import { TranslateConstructionPeriodPipe } from '@cfp/shared/ui/construction-period';
import { StreetViewImageComponent } from '@cfp/shared/ui/street-view-image';
import { Badge, Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  EnergyLabelTypeDTO,
  LabelGroupDTO,
  OwnershipStatusDTO,
  PortfolioBuildingsRoadmapBuildingDTO
} from 'csr-asset-app';
import { EnergyLabelRequirementDTO } from 'csr-energy-label-requirement';
import { LicenseDTO } from 'csr-login-app';

@Component({
  selector: 'cfp-report-buildings-table',
  templateUrl: 'report-buildings-table.html',
  styleUrls: ['report-buildings-table.scss'],
  imports: [
    EnergyLabel,
    Icon,
    StreetViewImageComponent,
    BuildingAddressDirective,
    TranslateModule,
    EnergyLabelRequirementStatus,
    DatePipe,
    Badge,
    TranslateConstructionPeriodPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportBuildingsTable {
  public readonly portfolioBuildingsRoadmapBuildings = input.required<PortfolioBuildingsRoadmapBuildingDTO[]>();
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');

  protected readonly EnergyLabelTypeDTO = EnergyLabelTypeDTO;
  protected readonly OwnershipStatusDTO = OwnershipStatusDTO;
  protected readonly labelGroup = LabelGroupDTO.EPC;

  private readonly userService = inject(UserService);

  protected readonly hasEnergyLabelRequirementLicense = toSignal(
    this.userService.hasLicense(LicenseDTO.LicenseTypeEnum.EnergyLabelRequirement)
  );

  protected mapToEnergyLabelRequirement(building: PortfolioBuildingsRoadmapBuildingDTO): EnergyLabelRequirementDTO {
    return building.energyLabelRequirement as EnergyLabelRequirementDTO;
  }

  protected translationKey(suffix: string): string {
    return `${this.translationKeyPrefix()}.${suffix}`;
  }
}
